export const userHasAccount = () => {
  return !!window.localStorage.getItem('__savvy_user_has_account');
};

export const logUserSignIn = () => {
  window.localStorage.setItem('__savvy_user_has_account', true);
};